/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Pass
 * 
 * 1 = Fail
 * 
 * 2 = NA
 */
export enum PressureTestResult {
  Pass = 0,
  Fail = 1,
  NA = 2
}
